import { render, staticRenderFns } from "./PendingEditRequestBirthdateValues.vue?vue&type=template&id=0902e04d&"
import script from "./PendingEditRequestBirthdateValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestBirthdateValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports